import React from 'react'

const Headers = (props) => {
  const object = JSON.parse(props.headers)
  return (
    <pre>
      {Object.keys(object).map((key) => {
        return (
          <div key={key}>
            <span style={{ fontWeight: 'bold' }}>{key}:</span>
            &nbsp;
            <span>{object[key]}</span>
          </div>
        )
      })}
    </pre>
  )
}

export default Headers
